import { useState } from "react";
import { DmLoadingSpinner } from "../../../manager/utils/functions";
import { Course, CourseGroup } from "../../types";
import { Transition } from "@headlessui/react";
import Button from "../../../student/components/generic/button";

const MAX_FEATURED_COURSES = 3;

export const ExpandableCourseList: React.FC<{
  getCourses: (isExpanded: boolean) => Course[] | undefined;
  courseGroups: CourseGroup[] | undefined;
  getButtonText: (isExpanded: boolean) => string;
  courseCardBanner?: string;
}> = ({ getCourses, courseGroups, getButtonText, courseCardBanner }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const courses = getCourses(isExpanded);

  const prepCourseGroup = courseGroups?.find((group) =>
    group.name.toLowerCase().includes("prep")
  );
  const isPrepCourse = (course: Course) =>
    course.groupId === prepCourseGroup?._id;

  if (!courses) {
    return (
      <div className="flex h-52 items-center justify-center">
        <DmLoadingSpinner message="" />
      </div>
    );
  }

  return (
    <>
      <ul className="flex grid-cols-3 flex-col gap-4 md:grid md:gap-6">
        {courses.map((course, index) => (
          <Transition
            key={course.id}
            show={index < MAX_FEATURED_COURSES || isExpanded}
            enter="transition ease-in duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            appear
          >
            <li className="relative flex h-full flex-col gap-4 rounded-lg border-2 border-dm-brand-blue-500 p-8 md:gap-6">
              <div className="flex flex-col-reverse md:flex-row md:items-center">
                <h5 className="flex-grow font-bold text-dm-brand-blue-600 md:font-serif md:text-2xl">
                  {course.name}
                </h5>
                {courseCardBanner && (
                  <div className="absolute -top-[13px] left-0 flex w-full justify-center">
                    <p className="flex h-[26px] items-center rounded-full bg-[#7BD78C] px-3 text-sm font-bold">
                      {courseCardBanner}
                    </p>
                  </div>
                )}
                <div className="relative mb-6 h-16 w-16 flex-none md:mb-0 md:ml-4">
                  <img
                    className="absolute left-1/2 top-1/2 -ml-12 -mt-12 h-24 w-24 max-w-24"
                    src={course.iconUrl}
                    alt={course.name}
                  />
                  {isPrepCourse(course) && (
                    <span className="absolute right-[5px] top-[5px] flex h-[13px] items-center rounded-full bg-[#F0A72E] px-2 py-0 text-[10px] uppercase">
                      Prep
                    </span>
                  )}
                </div>
              </div>
              {course.description && (
                <p className="line-clamp-3">{course.description}</p>
              )}
            </li>
          </Transition>
        ))}
      </ul>
      <Button
        className="mt-6 w-[396px] max-w-full text-sm md:mt-8"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {getButtonText(isExpanded)}
      </Button>
    </>
  );
};
